import React from 'react';
import { useSiteInfo } from '../../context/SiteInfoContext';

const Footer = () => {
  const { siteInfo } = useSiteInfo();
  const { phone, address, salesHours, usefulLinks, partnerLogos, footer } = siteInfo;

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-partners">
          {partnerLogos.map((logo) => (
            <div className="footer-partner" key={logo.alt}>
              <img src={logo.src} alt={logo.alt} loading="lazy" />
            </div>
          ))}
        </div>

        <div className="footer-content">
          <div className="footer-section footer-contact">
            <h4>{footer.contactHeading}</h4>
            <a href={`tel:${phone.tel}`} className="footer-phone">
              {phone.display}
            </a>
            <address className="footer-address">
              {address.lines.map((line) => (
                <span key={line}>{line}</span>
              ))}
            </address>
          </div>

          <div className="footer-section footer-hours">
            <h4>{footer.salesHeading}</h4>
            <ul className="footer-hours-list">
              {salesHours.map(({ day, hours }) => (
                <li key={day}>
                  <span className="footer-hours-day">{day}</span>
                  <span className="footer-hours-time">{hours}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-section footer-links-section">
            <h4>{footer.usefulLinksHeading}</h4>
            <ul className="footer-links">
              {usefulLinks.map((link) => (
                <li key={link.label}>
                  <a href={link.href}>{link.label}</a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          © {new Date().getFullYear()} {address.company}. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
